import {
  defaultBuildingCoverSI,
  mapBuildingCoverSI,
} from 'scenes/common/api/quote/marshaller/assets';
import { WireBuildingCoverSI } from 'scenes/common/api/quote/types';
import {
  getEstimatedSumInsured,
  getSumInsuredType,
  hasBuildingCoverType,
} from 'scenes/home/selectors';
import { HomeFunnelState } from 'scenes/home/types';

export const toWireBuildingCoverSI = (
  state: HomeFunnelState
): WireBuildingCoverSI =>
  hasBuildingCoverType(state)
    ? mapBuildingCoverSI(
        getSumInsuredType(state),
        getEstimatedSumInsured(state)
      )
    : defaultBuildingCoverSI;
